import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'flagIcon'
})
export class FlagIconPiPe implements PipeTransform {
    transform(code) {
        if (code) {
            const substrCode = (code.length <= 2 ? code : code.substring(0, 2)).toLowerCase();
            return `flag-icon flag-icon-${substrCode}`;
        }
        return '';
    }
}

